// extracted by css-extract-rspack-plugin
export default {"cls1":"StatelessWorkCardsUpsellModal-styles-cls1_-MN","cls2":"StatelessWorkCardsUpsellModal-styles-cls2_3ia StatelessWorkCardsUpsellModal-styles-cls1_-MN"};